/**
 * Κοινή μορφοποίηση τίτλου υπηρεσίας (ίδια λογική με ServiceTable.formatServiceTitle)
 * για επιλογή σε τιμολόγιο κλπ.
 */

import { isSubscriptionService } from './serviceListingFilters';

const formatServiceType = (type) => {
  const types = {
    development: 'Ανάπτυξη',
    hosting: 'Hosting',
    maintenance: 'Συντήρηση',
    design: 'Σχεδιασμός',
    domain: 'Domain',
    application: 'Εφαρμογή (SaaS)',
    support: 'Υποστήριξη',
    seo: 'SEO',
    consulting: 'Σύμβουλος',
    training: 'Εκπαίδευση',
    license: 'Άδεια Λογισμικού',
    other: 'Άλλο'
  };
  return types[type] || type;
};

const isSubscription = (service) => isSubscriptionService(service);

const formatDate = (dateString) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('el-GR');
};

/**
 * Πλήρης τίτλος: π.χ. "Hosting - Advanced (24/3/2026-24/3/2027)"
 */
export function formatServiceSelectionTitle(service) {
  if (!service) return '';
  const baseName = service.name || '';

  if (!isSubscription(service)) {
    return baseName;
  }

  const typePrefix = formatServiceType(service.service_type);
  let startDate = '';
  let endDate = '';
  if (service.start_date) {
    const f = formatDate(service.start_date);
    if (f) startDate = f;
  }
  if (service.end_date) {
    const f = formatDate(service.end_date);
    if (f) endDate = f;
  }

  if (startDate && endDate) {
    return `${typePrefix} - ${baseName} (${startDate}-${endDate})`;
  }
  if (startDate) {
    return `${typePrefix} - ${baseName} (${startDate})`;
  }
  return `${typePrefix} - ${baseName}`;
}

/**
 * Ταξινόμηση: νεότερες υπηρεσίες (created_at) πρώτα.
 */
export function sortServicesNewestFirst(services) {
  if (!Array.isArray(services)) return [];
  return [...services].sort((a, b) => {
    const ta = a.created_at ? new Date(a.created_at).getTime() : 0;
    const tb = b.created_at ? new Date(b.created_at).getTime() : 0;
    if (tb !== ta) return tb - ta;
    return (b.id || 0) - (a.id || 0);
  });
}
